import { combineReducers } from 'redux'

import { pclnBootstrapData } from './pclnBootstrapData'
import { searchResults } from './searchResults'
import { airSearchReq } from './airSearchRequest'
import { uiToggles } from './uiToggles'
import { ads } from './ads'
import { airlines } from './airlines'
import { calendarPricingMap } from './calendarPricingMap'
import { flags } from './flags'
import { aceContent } from './aceContent/aceContent.js'
import { seti } from './seti'
import { flexDatesRetail } from './flexDates/flexDatesRetail'
import { flexDatesExpressDeals } from './flexDates/flexDatesExpressDeals'
import { currentlyViewing } from './flexDates/currentlyViewing'
import { listingsMetaData } from './listingsMetaData'
import { priceBreakers } from './priceBreakers'

import {
  filterInfo,
  airlinesFilter,
  stopsFilter,
  airportsFilter,
  timeFilter,
  altDatesFilter,
  attributesFilter,
} from './filters'

import {
  activeTabId,
  listings,
  listingsIsLoading,
  listingsHasErrored,
  displayInfiniteScrollLoadMore,
  listingsLoadingMessage,
  fetchedInitialListings,
  brandReference,
} from './listings'

const listingsApp = () => {
  return combineReducers({
    pclnBootstrapData,
    searchResults,
    airSearchReq,
    aceContent,
    seti,

    // filters
    airlinesFilter,
    stopsFilter,
    airportsFilter,
    timeFilter,
    altDatesFilter,
    attributesFilter,
    filterInfo,

    uiToggles,
    ads,
    airlines,
    flags,

    // listings
    listingsMetaData,
    listings,
    listingsIsLoading,
    listingsHasErrored,
    fetchedInitialListings,
    listingsLoadingMessage,
    displayInfiniteScrollLoadMore,
    brandReference,

    // flex dates
    calendarPricing: flexDatesRetail,
    calendarPricingExpressDeals: flexDatesExpressDeals,
    calendarPricingMap,
    currentlyViewing,

    // SBS Tabs
    activeTabId,

    // Price Breakers
    priceBreakers,
  })
}

export { listingsApp }
